export default __webpack_public_path__ + "static/media/Ojo.af3b91a3.svg";